import { ConfigStateService, LocalizationService } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';
import { Component, Injector, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { NotificationType } from 'src/core/decorators/notification/notification-type.decorator';
import { EvaluationType } from 'src/core/models/generic-lookup-type/quality/evaluation-type.glt';
import { NotificationDto } from 'src/core/models/notification/notification.dto';
import { CADatePipe } from 'src/core/pipes/ca-date.pipe';
import { NotificationService } from 'src/core/services/notification/notification.service';
import { CAToasterHelperService } from 'src/core/services/toaster/ca-toaster-helper.service';

@Component({
    selector: 'ca-evaluation-objection-evaluator-notification',
    templateUrl: './evaluation-objection-evaluator-notification.component.html',
    styleUrls: ['./evaluation-objection-evaluator-notification.component.scss'],
    standalone: false
})
@NotificationType(
  'EvaluationObjectionEvaluatorNotification',
  EvaluationObjectionEvaluatorNotificationComponent
)
export class EvaluationObjectionEvaluatorNotificationComponent implements OnInit {
  data: NotificationDto;
  isObjected: boolean = true;

  get payloadData(): any {
    return JSON.parse(this.data?.payload);
  }

  get recipientId(): string {
    return this.data?.recipientId;
  }

  evaluationType = EvaluationType;

  constructor(private notificationService: NotificationService, private router: Router) {}

  ngOnInit(): void {}

  static showNotification(
    notificationId: string,
    payload: string,
    toastr: ToasterService,
    localizationService: LocalizationService,
    toasterHelperService: CAToasterHelperService,
    notificationService: NotificationService,
    injector: Injector,
    caDatePipe: CADatePipe,
    router: Router
  ) {
    const parsedPayload = JSON.parse(payload);
    const message = localizationService.instant(
      'QualityManagement::EvaluationObjectionEvaluatorToastrAndNotificationMessage'
    );

    const configStateService = injector.get(ConfigStateService);

    const currentUserId = configStateService.getDeep('currentUser.id');

    var toastrId = toastr.info(message);

    var toastrInstance = toasterHelperService.getToastById(toastrId);
    toastrInstance.onTap.pipe(take(1)).subscribe(() => {
      this.toasterClickedHandler(
        notificationService,
        notificationId,
        parsedPayload,
        router,
        currentUserId
      );
    });
  }

  static toasterClickedHandler(
    notificationService: NotificationService,
    notificationId: string,
    payload: any,
    router: Router,
    currentUserId: string
  ) {
    notificationService.markAsRead(notificationId).subscribe();
    this.navigateToEvaluation(payload, router, currentUserId);
  }

  static navigateToEvaluation(payloadData: any, router: Router, currentUserId: string) {
    if (payloadData?.conversationId) {
      const queryParams = {
        evaluationMasterId: payloadData?.evaluationId,
        evaluationResultId: payloadData?.evaluationResultId,
        referrer: 'evaluation-result',
      };

      router.navigate(['/conversation/v2/', payloadData?.conversationId, 'evaluation-result'], {
        queryParams: queryParams,
      });
    } else if (payloadData?.userId) {
      const queryParams = {
        evaluationMasterId: payloadData?.evaluationId,
        evaluationResultId: payloadData?.evaluationResultId,
        referrer: 'evaluation-result',
      };

      router.navigate(['quality', 'user-evaluation', payloadData?.userId, 'evaluation-result'], {
        queryParams: queryParams,
      });
    }
  }

  onLinkClicked() {
    if (this.data.markedAsRead === false) {
      this.notificationService.markAsRead(this.data.id).subscribe();
    }

    if (this.payloadData?.conversationId) {
      const queryParams = {
        evaluationMasterId: this.payloadData?.evaluationId,
        evaluationResultId: this.payloadData?.evaluationResultId,
        referrer: 'evaluation-result',
      };

      this.router.navigate(
        ['/conversation/v2/', this.payloadData?.conversationId, 'evaluation-result'],
        {
          queryParams: queryParams,
        }
      );
    } else if (this.payloadData?.userId) {
      const queryParams = {
        evaluationMasterId: this.payloadData?.evaluationId,
        evaluationResultId: this.payloadData?.evaluationResultId,
        referrer: 'evaluation-result',
      };

      this.router.navigate(
        ['quality', 'user-evaluation', this.payloadData?.userId, 'evaluation-result'],
        {
          queryParams: queryParams,
        }
      );
    }
  }
}
